//const baseURL="http://192.168.177.109:8055";
//const baseURL="http://directus.skidegodt.dk:3055/api";
const baseURL = "https://www.skidegodt.dk/api";
//const baseURL = "http://116.203.110.39:8055";
//const baseURL = "http://localhost:3055"
export default baseURL;


